import React, { useState, useEffect } from 'react';
import axios from './axios-config';
import swal from 'sweetalert';
import $ from 'jquery';
import { Card, CardBody, CardHeader } from 'reactstrap';

const Pagination = () => {
  const [miVariableB, setMiVariableB] = useState([]);


  let datos_ben=[];
  let parentesco_ben="";
  let miVariableX='';
  useEffect(async() => {

    axios.get(`${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/beneficiarios/`+$('#certificado').val(),{
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
      },
    }).then(json => {
         if (json.status === 200) {
                              if (json.data.tPolBeneficiario.length===undefined){
                                   /*se comenta porque aqui nunca entrará
                                              if (json.data.tPolBeneficiario.parentesco===1){
                                              parentesco_ben='Padre';
                                            }else if (json.data.tPolBeneficiario.parentesco===2){
                                              parentesco_ben = 'Madre';
                                            }else if (json.data.tPolBeneficiario.parentesco===3){
                                              parentesco_ben = 'Hermano';
                                            }else if (json.data.tPolBeneficiario.parentesco===4){
                                                parentesco_ben = 'Tio';
                                              }else if (json.data.tPolBeneficiario.parentesco===5){
                                                parentesco_ben = 'Abuelo';
                                              }else if (json.data.tPolBeneficiario.parentesco===6){
                                                  parentesco_ben = 'Conyugue';
                                                }else if (json.data.tPolBeneficiario.parentesco===7){
                                                  parentesco_ben = 'Hij(@)';
                                                }else if (json.data.tPolBeneficiario.parentesco===8){
                                                      parentesco_ben = 'Cuñado';
                                                    }else if (json.data.tPolBeneficiario.parentesco===9){
                                                      parentesco_ben = 'Suegro';
                                                    }else if (json.data.tPolBeneficiario.parentesco===10){
                                                        parentesco_ben = 'Novio';
                                                      }else if (json.data.tPolBeneficiario.parentesco===11){
                                                        parentesco_ben = 'No especificado';
                                                        }
                                                        else if (json.data.tPolBeneficiario.parentesco===12){
                                                            parentesco_ben = 'Amigo';
                                                          }else if (json.data.tPolBeneficiario.parentesco===13){
                                                            parentesco_ben = 'Sobrino';
                                                            }
                                                  else{
                                              parentesco_ben = 'No Especificado';
                                              }
                                      miVariableX =[{ID_BEN:1,NOMB_BEN:json.data.tPolBeneficiario.primerNombre +' '+json.data.tPolBeneficiario.primerApellido, PARENT_BEN:parentesco_ben,POR_BEN:json.data.tPolBeneficiario.porcentaje}];
                                      */

                                    }
                              else{
                                  for (var i = 0; i < json.data.tPolBeneficiario.length; i++) {
                                      /*
                                        if (json.data.tPolBeneficiario[i].parentesco===1){
                                        parentesco_ben='Padre';
                                      }else if (json.data.tPolBeneficiario[i].parentesco===2){
                                        parentesco_ben = 'Madre';
                                      }else if (json.data.tPolBeneficiario[i].parentesco===3){
                                        parentesco_ben = 'Hermano';
                                      }else if (json.data.tPolBeneficiario[i].parentesco===4){
                                          parentesco_ben = 'Tio';
                                        }else if (json.data.tPolBeneficiario[i].parentesco===5){
                                          parentesco_ben = 'Abuelo';
                                        }else if (json.data.tPolBeneficiario[i].parentesco===6){
                                            parentesco_ben = 'Conyugue';
                                          }else if (json.data.tPolBeneficiario[i].parentesco===7){
                                            parentesco_ben = 'Hij(@)';
                                          }else if (json.data.tPolBeneficiario[i].parentesco===8){
                                                parentesco_ben = 'Cuñado';
                                              }else if (json.data.tPolBeneficiario[i].parentesco===9){
                                                parentesco_ben = 'Suegro';
                                              }else if (json.data.tPolBeneficiario[i].parentesco===10){
                                                  parentesco_ben = 'Novio';
                                                }else if (json.data.tPolBeneficiario[i].parentesco===11){
                                                  parentesco_ben = 'No especificado';
                                                  }
                                                  else if (json.data.tPolBeneficiario[i].parentesco===12){
                                                      parentesco_ben = 'Amigo';
                                                    }else if (json.data.tPolBeneficiario[i].parentesco===13){
                                                      parentesco_ben = 'Sobrino';
                                                      }
                                            else{
                                        parentesco_ben = 'No Especificado';
                                        }*/

                                        parentesco_ben = json.data.tPolBeneficiario[i].descripcionParentesco;

                                        var vNombreben=json.data.tPolBeneficiario[i].primerNombre+' '+(json.data.tPolBeneficiario[i].segundoNombre?json.data.tPolBeneficiario[i].segundoNombre:'')
                                        +' '+json.data.tPolBeneficiario[i].primerApellido+' '+ (json.data.tPolBeneficiario[i].segundoApellido?json.data.tPolBeneficiario[i].segundoApellido:'')
                                        +' '+(json.data.tPolBeneficiario[i].apellidoCasada?' DE '+json.data.tPolBeneficiario[i].apellidoCasada:'');      

                                        //console.log(json.data.tPolBeneficiario[i].primerNombre+'  '+parentesco_ben+ '   '  +json.data.tPolBeneficiario[i].primerApellido);
                                          datos_ben.push({ID_BEN:i+1,NOMB_BEN:vNombreben, PARENT_BEN:parentesco_ben,POR_BEN:json.data.tPolBeneficiario[i].porcentaje});
                                  }
                                  miVariableX=datos_ben;
                                  //console.log('varios'+miVariableX);
                              }
                          setTimeout(
                           function()
                           {
                    //console.log('completado');
                           }, 9000);

                                setMiVariableB(miVariableX);
         } else {
           swal("Aviso", "La póliza no tiene beneficiarios registrados.", "info");
         }
       }).catch(function(error) {


       })
       //console.log("final"+miVariableB);
  }, []);


  return (
    <Card className="shadow-sm border-0 w-100">
      <CardHeader className="bg-white border-0 d-flex align-items-center">
        <div className="d-flex align-items-center">                  
        </div>
    </CardHeader>
    <CardBody className="pt-0">
      <div className="table-responsive">
        <table className="table mb-0 align-middle">
          <thead className="bg-light">
            <tr>
              <th className="px-3 py-3 text-uppercase text-muted small fw-bold" style={{ width: '60px' }}>ID</th>
              <th
                className="px-3 py-3 text-uppercase text-muted small fw-bold"
                style={{ minWidth: '260px' }}
              >
                Nombres y Apellidos
              </th>
              <th className="px-3 py-3 text-uppercase text-muted small fw-bold">Parentesco</th>
              <th className="px-3 py-3 text-uppercase text-muted small fw-bold text-end">
                Porcentaje
              </th>
            </tr>
          </thead>
          <tbody className="border-top-0">
            {miVariableB.map((ben) => (
              <tr key={ben.ID_BEN} className="align-middle">
                <td className="px-3 py-3 fw-semibold" style={{ width: '60px' }}>{ben.ID_BEN}</td>
                <td className="px-3 py-3 text-uppercase" style={{ minWidth: '260px' }}>{ben.NOMB_BEN}</td>
                <td className="px-3 py-3">{ben.PARENT_BEN}</td>
                <td className="px-3 py-3 text-end fw-semibold">{ben.POR_BEN}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardBody>
    </Card>
  );
};
export default Pagination;
